const e = (o = "old") => o === "new" ? "black-new" : void 0;
export {
  e as getTypographyDefaultColor
};
